import { CatalogItemWithKey } from 'src/models/catalog/CatalogItemWithKey';

export function compareFavoriteItem(item1: CatalogItemWithKey, item2: CatalogItemWithKey) {
  const nameComparisonRes = item1.data.label.localeCompare(item2.data.label);
  // 同名アイテムでない場合はそのままアイテム名で比較した結果を返す
  if (nameComparisonRes !== 0) {
    return nameComparisonRes;
  }

  // 美術品の贋作はunique_idの若い順でソートする
  if (item1.data.unique_id !== item2.data.unique_id) {
    return item1.data.unique_id - item2.data.unique_id;
  }

  // rebody_patternを持つ場合はrebody_patternに格納されている順番でソートする
  if (item1.data.type === 'body-variable' && item2.data.type === 'body-variable') {
    const rebodyPatternIndexes = item1.data.rebody_pattern?.map(pattern => pattern.index);

    if (
      item1.key.rebody_index === undefined ||
      item2.key.rebody_index === undefined ||
      !rebodyPatternIndexes
    ) {
      return 0;
    }

    const item1IndexOrder = rebodyPatternIndexes.indexOf(item1.key.rebody_index);
    const item2IndexOrder = rebodyPatternIndexes.indexOf(item2.key.rebody_index);

    if (item1IndexOrder !== -1 && item2IndexOrder !== -1) {
      return item1IndexOrder - item2IndexOrder;
    } else {
      return 0;
    }
  }

  // variationsを持つ場合はvariationsに格納されている順番でソートする
  if (item1.data.type === 'color-variable' && item2.data.type === 'color-variable') {
    const colorVariationUniqueIds = item1.data.variations.map(variation => variation.unique_id);

    const item1IUniqueIdOrder = colorVariationUniqueIds.indexOf(item1.key.unique_id);
    const item2UniqueIdOrder = colorVariationUniqueIds.indexOf(item2.key.unique_id);

    if (item1IUniqueIdOrder !== -1 && item2UniqueIdOrder !== -1) {
      return item1IUniqueIdOrder - item2UniqueIdOrder;
    } else {
      return 0;
    }
  }

  // どの条件にも引っかからない場合はアイテム順を変えないようにする
  return 0;
}
